import { secondsToMs } from '@/utils/datetime/unitToMs'
import ky from 'ky'

export let api = ky.create({
	headers: {
		'Content-Type': 'application/json'
	},
	timeout: secondsToMs(20)
})
